// extracted by mini-css-extract-plugin
module.exports =  {"adminGitHubIssueForm":"JPgQe8qm"};